'use strict';

var _ = require('lodash');

function DialogViewController ($scope, DialogViewFactory) {
  var DEFAULTS = {
    id: '',
    group: '', // dialog group the view belongs to
    show: false,
    subtitle: '',
    title: '',
  };

  var vm = this;
  var isShowing = false;
  var viewFactory = null;

  vm.init = function (group) {
    _.defaults(vm, DEFAULTS);
    vm.group = group;

    viewFactory = new DialogViewFactory(group);
    viewFactory.register(vm.id, vm);
  };

  /**
   * Creates a function that when executed will return the current value of 'show'
   * 
   * @return {Fn} when executed will return the current value of 'show'
   */
  vm.watchShow = function () {
    return ctrlAttr('show');
  };

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Helpers
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  /**
   * Used internally to create a function that will retrieve a given controller attribute 
   * for $watch
   * 
   * @param  {String} attr
   * @return {Fn}
   */
  function ctrlAttr (attr) {
    return function () {
      return vm[attr];
    };
  }

  ///////////////////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  ///////////////////////////////////////////////////////////////////////////////////////////
  
  function onDestroy () {
    viewFactory.removeView(vm.id);
  }

  function onShowChange (show) {
    if (show && isShowing || !show && !isShowing) {
      return;
    } else if (show) {
      isShowing = true;
    } else {
      isShowing = false;
    }
  }

  $scope.$watch(ctrlAttr('show'), onShowChange);
  $scope.$on('$destroy', onDestroy);
}

module.exports = DialogViewController;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/dialog/src/dialogView/DialogViewController.js